import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../i18n';
import Button from '../Button';
import Drawer from '../Drawer';

interface Props {
  isOpen: boolean;
  children: ReactNode;
  onCancel: () => any;
  onSubmit: () => any;
}

const DefaultCreateFormulaOverlay = ({ isOpen, children, onCancel, onSubmit }: Props) => {
  const { t } = useTranslation([i18nNS.COMMON, i18nNS.GLOSSARY]);

  return (
    <Drawer
      open={isOpen}
      anchor="right"
      dismissal="none"
      onClose={onCancel}
      header={t('inserting_math_expression', { ns: i18nNS.COMMON })}
      footer={
        <>
          <Button variant="text" onClick={onCancel}>
            {t('cancel', { ns: i18nNS.GLOSSARY })}
          </Button>
          <Button onClick={onSubmit} aria-label={t('click_to_use_this_formula', { ns: i18nNS.COMMON })}>
            {t('use', { ns: i18nNS.GLOSSARY })}
          </Button>
        </>
      }
    >
      {children}
    </Drawer>
  );
};

export default DefaultCreateFormulaOverlay;
